import moment from "moment-timezone";
import React, { useEffect, useState } from "react";
import Modal from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { useRecoilState } from "recoil";
import { getRecoil, resetRecoil } from "recoil-nexus";
import styled from "styled-components";
import ApiController from "../../controller/ApiController";
import { alarmState } from "../../recoil/alarm";
import { csChatListState, newChatListState } from "../../recoil/chat";
import { langState, langText } from "../../recoil/lang";
import { OrderDataType } from "../../recoil/type";
import "../../styles/CustomModal.css";

const SelectChatModal = (oProps: {
  isVisible: boolean;
  setVisible: any;
  openChatRoom: any;
}) => {
  const [lang, setLang] = useRecoilState<number>(langState);
  const [isOpenStore, setIsOpenStore] = useState<boolean>(true);
  const [isOpenAdmin, setIsOpenAdmin] = useState<boolean>(true);

  const [orderDataList, setOrderDataList] = useState<OrderDataType[]>([]);

  const getOrderByUserTokenId = async () => {
    try {
      const oRes: any = await ApiController.order.getOrderByUserTokenId();

      if (oRes && oRes.data) {
        const oResponse: any = oRes.data;
        console.log("getOrderByUserTokenId", oResponse);
        setOrderDataList([...oResponse]);
      }
    } catch (err) {
      console.log("err-->", err);
    }
  };

  const onCloseModal = () => {
    resetRecoil(alarmState);
    oProps.setVisible(false);
  };

  const openOrderChat = (order: OrderDataType) => {
    oProps.setVisible(false);
    console.log("open cs");
    oProps.openChatRoom(true, order);
  };

  const openAdminChat = () => {
    oProps.setVisible(false);
    console.log("open cs");
    oProps.openChatRoom(false);
  };

  const getFilterChatOrder = (order: OrderDataType) => {
    console.log("newChatListFlag", getRecoil(newChatListState));
    return getRecoil(newChatListState).findIndex(
      (item) =>
        item.order_id === order.order_id &&
        item.order_seq === order.order_seq &&
        item.store_id === order.store_id
    ) > -1
      ? true
      : false;
  };

  const getFilterChatCs = () => {
    console.log("getFilterChatCs", getRecoil(csChatListState));
    return getRecoil(csChatListState);
  };

  useEffect(() => {
    if (oProps.isVisible) {
      getOrderByUserTokenId();
      setTimeout(() => {
        setIsOpenStore(true);
        setIsOpenAdmin(true);
      }, 100);
    } else {
      setIsOpenStore(false);
      setIsOpenAdmin(false);
    }
  }, [oProps.isVisible]);

  return (
    <Modal
      open={oProps.isVisible}
      onClose={onCloseModal}
      center
      classNames={{
        overlay: "selectChatModalOverlay",
        modal: "inivisibleModal",
      }}
      closeOnOverlayClick={true}
      animationDuration={150}
      // showCloseIcon={true}
      // closeIcon={
      //   <img
      //     className="closeIcon"
      //     onClick={onCloseModal}
      //     src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
      //     alt="닫기 아이콘"
      //   />
      // }
    >
      <Style>
        <div className="modal">
          <div className="boxWrap">
            <div
              className="box store"
              onClick={() => setIsOpenStore(!isOpenStore)}
            >
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_store.svg`}
                alt="store"
              />
              <h2>{langText.selectChatModal_store_title[lang]}</h2>
              <h4>{langText.selectChatModal_store_comment[lang]}</h4>
            </div>
            <div className={`listWrap ${isOpenStore && "open"}`}>
              {orderDataList.length > 0 ? (
                orderDataList.map((item, index) => (
                  <div
                    className="listItem"
                    key={index}
                    onClick={() => openOrderChat(item)}
                  >
                    <h3 className="index">{index + 1}</h3>
                    <div className="item">
                      <h4 className="date">
                        {moment(item.created_at).format("MM/DD HH:mm")}
                      </h4>
                      {getFilterChatOrder(item) && (
                        <div className="newBadge">N</div>
                      )}
                      <h2>{item.store_name}</h2>
                    </div>
                  </div>
                ))
              ) : (
                <div className="listItem none">
                  <h4>{langText.selectChatModal_no_order[lang]}</h4>
                </div>
              )}
            </div>
          </div>
          <div className="boxWrap">
            <div
              className="box admin"
              onClick={() => setIsOpenAdmin(!isOpenAdmin)}
            >
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_chat.svg`}
                alt="admin"
              />
              <h2>{langText.knock_support[lang]}</h2>
              <h4>{langText.selectChatModal_cs_comment[lang]}</h4>
            </div>
            <div className={`listWrap cs ${isOpenAdmin && "open"}`}>
              <div className="listItem">
                <h3>{langText.kakaotalk_link[lang]}</h3>
                <div className="content">
                  <img
                    src={`${process.env.PUBLIC_URL}/knockknock/img/knockCustomerQRcode.png`}
                    alt="고객센터 qr코드"
                  />
                </div>
              </div>
              <div className="listItem">
                <h3>{langText.email[lang]}</h3>
                <div className="content">
                  <h3 className="email">{"knockcs\n@ivid.kr"}</h3>
                </div>
              </div>
              <div className="listItem" onClick={openAdminChat}>
                {getFilterChatCs() && <div className="newBadge">N</div>}
                <h3>{langText.contact_chat[lang]}</h3>
                <div className="content">
                  <p>{langText.contact_comment[lang]}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default SelectChatModal;

const Style = styled.div`
  .modal {
    display: flex;
    align-items: flex-start;
    gap: 30px;
  }

  .boxWrap {
    width: 38vw;
    display: flex;
    flex-direction: column;
  }
  .box {
    height: 38vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    justify-content: space-around;
    border-radius: 20px;
    padding: 8% 2%;
    margin: 0;
    background: #343434;
    z-index: 1;
    cursor: pointer;
    img {
      min-height: 30%;
      max-height: 30%;
    }
    h2 {
      font-size: 28px;
      line-height: 30px;
      font-weight: 700;
      word-break: keep-all;
    }
    h4 {
      font-size: 16px;
      line-height: 20px;
      font-weight: 400;
      color: #e5e5e5;
    }
  }
  .box.store {
    background: #b090ff;
    h2 {
      color: #fff;
    }
  }
  .box.admin {
    background: #4dd2ae;

    h2 {
      color: #fff;
    }
  }

  .listWrap {
    margin-top: -20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 10px 0 10px;
    gap: 4px;
    height: 0;
    margin-bottom: 420px;
    background: #222222;
    overflow: auto;
    border-radius: 0 0 10px 10px;
    .listItem {
      position: relative;
      width: 100%;
      padding: 20px 10px;
      display: flex;
      border-bottom: 1px solid #333333;
      cursor: pointer;
      gap: 10px;

      .item {
        width: 100%;
      }

      h2 {
        font-weight: 600;
        color: #fff;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        -webkit-line-clamp: 2;
        text-overflow: ellipsis;
      }
      h3.index {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 26px;
        height: 26px;
        border-radius: 5px;
        border: 1px solid #a7a7a7;
        font-size: 18px;
        line-height: 18px;
        font-weight: 600;
        color: #fff;
      }

      h4.date {
        line-height: 22px;
        font-weight: 400;
      }
    }

    .listItem.none {
      padding-top: 50px;
      align-items: center;
      justify-content: center;
      border: none;

      h4 {
        font-size: 18px;
        line-height: 24px;
        font-weight: 600;
      }
    }
  }

  .newBadge {
    position: absolute;
    top: 20px;
    right: 10px;
    width: 20px;
    height: 20px;
    font-size: 12px;
    line-height: 12px;
    color: #fff;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100px;
    background: #ff4a4a;
  }

  .listWrap.cs {
    justify-content: flex-end;
    padding: 0 30px 0 30px;

    h3 {
      font-size: 20px;
      line-height: 28px;
      font-weight: 500;
    }
    h3.email {
      font-size: 16px;
      line-height: 26px;
      font-weight: 600;
    }
    p {
      font-size: 12px;
      line-height: 20px;
      font-weight: 300;
    }

    .line {
      width: 100%;
      border: 1px solid #333333;
    }

    .listItem {
      width: 100%;
      padding: 20px 14px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 20px;

      .content {
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 80px;
        height: 80px;
        img {
          height: 100%;
        }
      }

      .newBadge {
        top: 16px;
        right: 0;
      }
    }
  }
  .listWrap.open {
    height: 420px;
    padding-top: 40px;
    padding-bottom: 10px;
    margin-bottom: 0;
    transition: height 0.5s ease, padding-top 0.5s ease,
      padding-bottom 0.5s ease, margin-bottom 0.5s ease;
  }
`;
